import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import {LabelItem} from "../../model/items/labelItem";
import SliderBox from "../shared/components/SliderBox/SliderBox";
import {SliderItem} from "../../model/items/slider";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";
import {CheckboxItem} from "../../model/items/checkbox";


export abstract class BaseSlider extends CustomForm
{
    protected sliderBoxes: SliderBox[] = [];
    protected checkboxCells: CheckboxCell[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const sliders: SliderItem[] = [];

        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof SliderItem) {
                    sliders[cell.row] = cellItem;
                } else if (cellItem instanceof CheckboxItem) {
                    this.checkboxCells.push(new CheckboxCell(
                        cell,
                        (ci, v) => this.onSetValue(ci, v)
                    ));
                }
            }
        }

        for (const i in sliders) {
            this.sliderBoxes.push( new SliderBox(
                sliders[i],
                sliders[i].labels.left,
                sliders[i].labels.right,
            ));
        }
    }

    public rewriteFormControls(): boolean {
        return true;
    }

    public checkRequirements(): boolean
    {
        if (this.sliderBoxes.length === 0) {
            console.log('customForm-Slider: Unable to find any slider.');
            return false;
        }

        return true;
    }

}